import React from "react";

const OrderCell = ({ props }) => {
    let orderAttribute = props?.schema?.key ?? "order";
    let data = props.data;
    let orderIndex = props?.tableProps?.tableColumns?.indexOf(orderAttribute) ?? 6;

    let colIndex = data[orderIndex];
    let rowIndex = props.rowIndex;
    let totalRows = props.tableProps.tableData.length;

    // Use rowIndex to determine if arrows should be shown
    let canShowUp = rowIndex !== 0;
    let canShowDown = rowIndex !== totalRows - 1;

    let colIndexText = "";
    if (colIndex === 1) {
        colIndexText = "first";
    } else if (colIndex === props.tableProps.tableData.length) {
        colIndexText = "last";
    }
    // console.log("current index: " + colIndex);
    let textValue = data[colIndex];
    const fun = props?.tableProps?.setOrderChanged;

    const orderHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let orderObj = {
            action: e.currentTarget.dataset.action,
            // current: e.currentTarget.dataset.current,
            current: rowIndex, // pass the real row index
        };
        fun(orderObj);
    };

    return <div className="indi-table-cell-order d-flex">
        {canShowUp &&
            <div
                role="button"
                data-action="minus"
                data-current={`${colIndex}`}
                onClick={orderHandler}
                className={`indi-table-cell-order-up indi-table-cell-order-action indi-table-cell-order-action-${colIndexText}`}>
            </div>
        }
        {/* :{colIndex}: */}
        {canShowDown &&
            <div
                data-action="plus"
                data-current={`${colIndex}`}
                onClick={orderHandler}
                className={`indi-table-cell-order-down indi-table-cell-order-action indi-table-cell-order-action-${colIndexText}`}>
            </div>
        }
    </div>
};

export default OrderCell;
